export default __webpack_public_path__ + "static/media/atlasware.faa24295.webp";